import React, { FC, ReactNode } from 'react';
import { LCDD } from './LCDD';
import isEmpty from 'lodash/isEmpty';

export interface InputDropdownOptions {
    current: string;
    all: Record<string, string>;
}
interface Props {
    onValueChange: (value: any, key: string) => void;
    options: InputDropdownOptions;
    className?: string;
}
const LCFormFieldInputDropdown: FC<Props> = props => {
    const list = props.options ?? {};
    const currentValue = list.current;
    const listItems: ReactNode[] = [];

    if (isEmpty(list)) {
        return null;
    }

    Object.entries(list.all).forEach(([key, value]) => {
        listItems.push(
            <li key={key} onClick={() => props.onValueChange(value, key)}>
                {value}
            </li>
        );
    });

    return (
        <LCDD
            label={currentValue}
            className={`dropdown-lc lc-input${props.className ? `\u0020${props.className}` : ''}`}
        >
            <ul>{listItems}</ul>
        </LCDD>
    );
};

export default LCFormFieldInputDropdown;
